import { api } from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

// Enregistre le SW et abonne l'utilisateur aux notifications push.
// force=true => demande l'autorisation (à appeler sur un geste utilisateur).
export async function subscribeToPush(force = false) {
  try {
    if (!("serviceWorker" in navigator) || !("PushManager" in window) || !("Notification" in window)) return false;
    const { data } = await api.get("/push/public-key");
    if (!data.enabled || !data.publicKey) return false;
    const reg = (await navigator.serviceWorker.getRegistration("/")) || (await navigator.serviceWorker.register("/sw.js", { scope: "/" }));
    await navigator.serviceWorker.ready;
    if (Notification.permission === "denied") return false;
    if (Notification.permission !== "granted") {
      if (!force) return false; // ne demande l'autorisation que sur un geste
      const perm = await Notification.requestPermission();
      if (perm !== "granted") return false;
    }
    const appKey = urlBase64ToUint8Array(data.publicKey);
    let sub = await reg.pushManager.getSubscription();
    // Re-subscribe if the existing subscription used a different VAPID key.
    if (sub) {
      const existing = sub.options && sub.options.applicationServerKey;
      const sameKey = existing && new Uint8Array(existing).toString() === appKey.toString();
      if (!sameKey) {
        try { await sub.unsubscribe(); } catch (e) { /* ignore */ }
        sub = null;
      }
    }
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: appKey,
      });
    }
    await api.post("/push/subscribe", { subscription: sub.toJSON() });
    return true;
  } catch (e) {
    return false;
  }
}

// Renvoie l'état actuel des notifications push pour cet appareil.
// { supported, permission: 'granted'|'denied'|'default', subscribed }
export async function getPushStatus() {
  const supported = "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
  if (!supported) return { supported: false, permission: "default", subscribed: false };
  let subscribed = false;
  try {
    const reg = await navigator.serviceWorker.getRegistration("/");
    if (reg) {
      const sub = await reg.pushManager.getSubscription();
      subscribed = !!sub;
    }
  } catch (e) { /* ignore */ }
  return { supported: true, permission: Notification.permission, subscribed };
}

// Désabonne cet appareil des notifications push.
export async function unsubscribeFromPush() {
  try {
    if (!("serviceWorker" in navigator)) return false;
    const reg = await navigator.serviceWorker.getRegistration("/");
    if (!reg) return true;
    const sub = await reg.pushManager.getSubscription();
    if (!sub) return true;
    try { await api.post("/push/unsubscribe", { subscription: sub.toJSON() }); } catch (e) { /* ignore */ }
    await sub.unsubscribe();
    return true;
  } catch (e) {
    return false;
  }
}
